import React from 'react';
import { compose } from '@/utils/story-composer';

function Page({ elementProps, body }) {
	return <div {...elementProps}>{body}</div>;
}

export default Page;

compose('page', Page, { children: ['body'] });
